import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminTopBar from "./AdminTopBar";
import { useNavigate, useParams } from "react-router-dom";
import api from "./api/axios";
import { useActivityLogger } from "./hooks/useActivity";
import { getImageUrl } from "./utils/image";


export default function AdminUpdateCommunity() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [imagePreview, setImagePreview] = useState(null);
  const { logAdminActivity } = useActivityLogger();
  const [formData, setFormData] = useState({
    nama_komunitas: "",
    nomor_hp: "",
    website: "",
    facebook: "",
    instagram: "",
    whatsapp: "",
    twitter: "",
    tiktok: "",
    telegram: "",
    image: null,
  });

  useEffect(() => {
    const fetchCommunity = async () => {
      try {
        const res = await api.get(`/komunitas/${id}`);
        setFormData(res.data);
        if (res.data.image_url) {
          // setImagePreview(
          //   `${process.env.REACT_APP_MEDIA_BASE}${res.data.image_url}`,
          // );
          setImagePreview(getImageUrl(res.data.image_url));
        }
      } catch (err) {
        console.error("Failed to fetch community data", err);
      }
    };
    logAdminActivity(
      "view",
      "view_admin_update_community",
      "community",
      id,
      formData.nama_komunitas || "Unknown Community",
      "success",
      "",
      `Admin membuka halaman update komunitas ${formData.nama_komunitas || "Unknown Community"}`
    );
    fetchCommunity();
  }, [id]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
      setFormData({ ...formData, image: file });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = new FormData();
    for (const key in formData) {
      if (formData[key]) {
        payload.append(key, formData[key]);
      }
    }

    try {
      await api.put(`/komunitas/${id}`, payload,  {headers: { "Content-Type": "multipart/form-data" },});
      logAdminActivity(
        "update",
        "update_community",
        "community",
        id,
        formData.nama_komunitas || "Unknown Community",
        "success",
        "",
        `Admin berhasil memperbarui komunitas ${formData.nama_komunitas || "Unknown Community"}`
      );
      alert("Komunitas berhasil diperbarui");
      navigate("/admin/community");
    } catch (error) {
      console.error("Update gagal", error);
      alert("Gagal memperbarui komunitas");
    }
  };

  return (
    <div className="min-h-screen flex">
      <AdminSidebar />
      <div className="flex-1 p-6 bg-gray-50">
        <AdminTopBar />

        <div className="bg-white p-6 rounded shadow">
          <button
            onClick={() => navigate(-1)}
            className="text-xl text-black font-semibold mb-8"
          >
            &lt; Update Komunitas
          </button>

          <form
            className="grid grid-cols-1 md:grid-cols-2 gap-4"
            onSubmit={handleSubmit}
          >
            <div>
              <label className="text-sm block mb-1">Nama Komunitas</label>
              <input
                name="nama_komunitas"
                type="text"
                value={formData.nama_komunitas}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div className="md:row-span-3 flex items-center justify-center border rounded relative overflow-hidden">
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="object-contain h-full w-full"
                />
              ) : (
                <span className="text-gray-400 text-sm">📷 Upload Foto</span>
              )}
              <input
                type="file"
                name="image"
                accept="image/*"
                onChange={handleImageChange}
                className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">No. HP</label>
              <input
                name="nomor_hp"
                type="text"
                value={formData.nomor_hp}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">Website</label>
              <input
                name="website"
                type="text"
                value={formData.website}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>

            <div className="md:col-span-2 mt-4">
              <label className="text-sm block mb-1">Media Sosial</label>
            </div>

            <div>
              <label className="text-sm block mb-1">Facebook</label>
              <input
                name="facebook"
                type="text"
                value={formData.facebook}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">Instagram</label>
              <input
                name="instagram"
                type="text"
                value={formData.instagram}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">WhatsApp</label>
              <input
                name="whatsapp"
                type="text"
                value={formData.whatsapp}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">X</label>
              <input
                name="twitter"
                type="text"
                value={formData.twitter}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">TikTok</label>
              <input
                name="tiktok"
                type="text"
                value={formData.tiktok}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">Telegram</label>
              <input
                name="telegram"
                type="text"
                value={formData.telegram}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>

            <div className="md:col-span-2 flex justify-end">
              <button
                type="submit"
                className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
